/**
 * eraOrigins — canonical lat/lon origin per era, shared across the
 * GlobeSpinIntro (entry pinhole), GlobeArcTransition (cross-reference
 * jumps), and any future map overlays.
 *
 * Apr 28-29 2026: most chain payloads don't carry explicit `origin.lat`
 * / `origin.lon` because the contest data model focuses on cause-effect
 * prose. Until the schema absorbs explicit coords, these era defaults
 * give the cinematic spin / arc a sensible regional anchor — "deep
 * time" lands in the East African Rift, "classical" lands in Rome,
 * etc. Override per-chain when the data model catches up.
 */
export const ERA_ORIGIN = {
  deep_time:    { lat: 9.0,   lon: 38.0,   label: 'East African Rift' },
  ancient:      { lat: 30.0,  lon: 31.0,   label: 'Nile Valley' },
  classical:    { lat: 41.9,  lon: 12.5,   label: 'Rome' },
  medieval:     { lat: 48.85, lon: 2.35,   label: 'Paris' },
  early_modern: { lat: 51.5,  lon: -0.13,  label: 'London' },
  colonial:     { lat: 38.9,  lon: -77.0,  label: 'Washington, D.C.' },
  industrial:   { lat: 53.48, lon: -2.24,  label: 'Manchester' },
  modern:       { lat: 40.71, lon: -74.0,  label: 'New York' },
  contemporary: { lat: 37.77, lon: -122.4, label: 'San Francisco' },
};

export function resolveEraOrigin(eraOrChain) {
  if (!eraOrChain) return ERA_ORIGIN.modern;
  // Accept either a string era key or a chain-like object.
  if (typeof eraOrChain === 'string') {
    return ERA_ORIGIN[eraOrChain] || ERA_ORIGIN.modern;
  }
  // Chain object: prefer explicit origin.lat/lon, fall back to era.
  if (typeof eraOrChain?.origin?.lat === 'number' && typeof eraOrChain?.origin?.lon === 'number') {
    return {
      lat: eraOrChain.origin.lat,
      lon: eraOrChain.origin.lon,
      label: eraOrChain.origin.location || eraOrChain.title || '',
    };
  }
  const era = eraOrChain.era || 'modern';
  return ERA_ORIGIN[era] || ERA_ORIGIN.modern;
}
